// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2lwjj","questions":"styles_questions__J0lVG","footer":"styles_footer__827Jz"};